import { render } from "./lock-screen.vue?vue&type=template&id=4c673956"
import script from "./lock-screen.vue?vue&type=script&lang=js"
export * from "./lock-screen.vue?vue&type=script&lang=js"

import exportComponent from "/home/krupali/vuejs/borex-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__